// 라우트 경로 상수

export const ROUTES = {
  LOGIN: "/login",
  DASHBOARD: "/dashboard",
  DASHBOARD_ANALYTICS: "/dashboard/analytics",
  DASHBOARD_USERS: "/dashboard/users",
  DASHBOARD_USER_DETAIL: (userId: number) => `/dashboard/users/${userId}`,
  DASHBOARD_COURSES: "/dashboard/courses",
  DASHBOARD_COURSE_NEW: "/dashboard/courses/new",
  DASHBOARD_COURSE_DETAIL: (courseId: number) => `/dashboard/courses/${courseId}`,
  DASHBOARD_COURSE_EDIT: (courseId: number) => `/dashboard/courses/${courseId}/edit`,
  DASHBOARD_LESSON_DETAIL: (lessonId: number) => `/dashboard/lessons/${lessonId}`,
  DASHBOARD_LESSON_NEW: (courseId: number, chapterId: number) => `/dashboard/courses/${courseId}/chapters/${chapterId}/lessons/new`,
  DASHBOARD_LESSON_EDIT: (lessonId: number) => `/dashboard/lessons/${lessonId}/edit`,
  DASHBOARD_PRODUCTS: "/dashboard/products",
  DASHBOARD_PAYMENTS: "/dashboard/payments",
  DASHBOARD_PAYMENT_DETAIL: (paymentId: number) => `/dashboard/payments/${paymentId}`,
  DASHBOARD_ORDER_SHEET_DETAIL: (orderSheetId: number) => `/dashboard/order-sheets/${orderSheetId}`,
  DASHBOARD_INSTRUCTORS: "/dashboard/instructors",
  DASHBOARD_SETTINGS: "/dashboard/settings",
  DASHBOARD_PROFILE: "/dashboard/profile",
  DASHBOARD_CHANGE_PASSWORD: "/dashboard/profile/change-password",
} as const;



